
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { FloatingTradeWidget } from "./FloatingTradeWidget";
import { useToast } from "@/hooks/use-toast";

interface TradeRequest {
    ticker: string;
    type: "buy" | "sell";
    amount: number;
}

export function GlobalTradeHandler() {
    const [isOpen, setIsOpen] = useState(false);
    const [coinData, setCoinData] = useState<any>(null);
    const { toast } = useToast();

    useEffect(() => {
        const handleOpenTrade = async (e: Event) => {
            const detail = (e as CustomEvent<TradeRequest>).detail;
            if (!detail || !detail.ticker) return;

            try {
                const { data, error } = await supabase
                    .from("coins")
                    .select("*")
                    .ilike("ticker", detail.ticker)
                    .maybeSingle();

                if (error) throw error;

                if (!data) {
                    toast({
                        title: "Token Not Found",
                        description: `Could not find a token with ticker $${detail.ticker}`,
                        variant: "destructive"
                    });
                    return;
                }

                setCoinData(data);
                setIsOpen(true);

                // Optional: We could pre-fill the form in FloatingTradeWidget if we extended its props
                // For now, opening it with the correct coin is a huge win.
            } catch (err) {
                console.error("Failed to fetch coin for trade:", err);
                toast({
                    title: "Error",
                    description: "Failed to load token details.",
                    variant: "destructive"
                });
            }
        };

        window.addEventListener("open-trade", handleOpenTrade);
        return () => window.removeEventListener("open-trade", handleOpenTrade);
    }, []);

    if (!isOpen || !coinData) return null;

    return (
        <FloatingTradeWidget
            coin={coinData}
            onClose={() => setIsOpen(false)}
            defaultPosition={{ x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 200 }}
        />
    );
}
